import React, { useContext } from "react";
import { LoadingContext } from "../SignInSecurity/LoadingProvider";

const backDropStyles = {
  height: "100%",
  left: 0,
  zIndex: 1000,
  position: "fixed",
};

const Loading = (props) => {
  const { spinnerStyle } = props;
  const { loadingCount, isOpaque } = useContext(LoadingContext);
  const loaderClasses = isOpaque ? "pre-loader opaque" : "pre-loader";
  return (
    (loadingCount > 0) && (
      <div className="hd-coverup fade-in pre-loader-container">
        <div style={backDropStyles} className={loaderClasses}>
          <div style={spinnerStyle} className="segment-spinner" />
        </div>
      </div>
    )
  );
};

export default Loading;
